const images = require.context('@/assets/img/unit-galery', false, /\.png$/)

// unit status (getUnitsStatusesById) -> image variant; no status -> 'original'
const variantsByStatus = {
    moving: 'moving',
    idling: 'idle',
    parked: 'online',
    offline: 'offline',
    not_connection: 'offline',
}

// icon: '<category>__<name>', file: '<category>__<name>__<variant>.png'
export function getUnitGaleryIconSrc(icon, status) {
    try {
        return images(`./${icon}__${variantsByStatus[status] || 'original'}.png`)
    } catch (e) {
        return ''
    }
}
